export default __webpack_public_path__ + "static/media/KidcoGrillGuide1@2x.a581e072.jpg";